import { localize } from "utils/localizer";

const i18n = {
    activities: {
        en: "Activities",
        de: "Aktivitäten",
    },
    all: {
        en: "All",
        de: "Alle",
    },
    at: {
        en: "at",
        de: "um",
    },
    bookingCancelled: {
        en: (actor: string) => `${actor} hat die Buchung storniert`,
    },
    bookingCancelledPassive: {
        en: "Eine Buchung wurde abgesagt",
    },
    bookingCheckedIn: {
        en: (actor: string) => `${actor} hat eingecheckt`,
    },
    bookingCreated: {
        en: (actor: string) => `${actor} created a booking`,
        de: (actor: string) => `${actor} hat eine Buchung erstellt`,
    },
    bookingDescChanged: {
        en: (actor: string) => `${actor} hat die Beschreibung einer Buchung bearbeitet`,
    },
    bookingDetails: {
        en: "Booking Details",
        de: "Details zur Buchung",
    },
    bookingFinalized: {
        en: "Eine Buchung wurde final",
    },
    bookingPending: {
        en: "Eine Buchung wurde als ausstehend markiert",
    },
    bookingTimeChanged: {
        en: (actor: string) => `${actor} hat eine Buchung verschoben`,
    },
    bookingTransformed: {
        en: (actor: string, type: string) => `${actor} hat ein Treffen zu einer ${type} Buchung transformiert`,
    },
    bookingTypes: {
        en: {
            blocking: "Blocking",
            meetup: "Meetup",
            standard: "Booking",
            training: "Event",
        },
        de: {
            blocking: "Sperrung",
            meetup: "Treffen",
            standard: "Buchung",
            training: "Event",
        },
    },
    cancellationRequested: {
        en: (actor: string) => `${actor} hat die Stornierung einer Buchung angefragt`,
    },
    club: {
        en: "Location",
        de: "Sportstätte",
    },
    description: {
        en: "Description",
        de: "Beschreibung",
    },
    endTime: {
        en: "End Time",
        de: "Endzeit",
    },
    fallbackSolution: {
        en: (subject: string, key: string, value: string) => `${subject} hat ${key} auf ${value} gesetzt`,
    },
    fallbackSolutionPassive: {
        en: (key: string, value: string) => `${key} wurde ${value}`,
    },
    invitationStatus: {
        en: {
            accepted: "accepted",
            pending: "pending",
            declined: "declined",
        },
        de: {
            accepted: "angenommen",
            pending: "ausstehend",
            declined: "abgelehnt",
        },
    },
    invitationStatusChanged: {
        en: (actor: string, accepted: boolean) => `${actor} hat die Einladung ${accepted ? "angenommen" : "abgelehnt"}`,
    },
    otherChanged: {
        en: (actor: string, name: string, status: string) => `${actor} hat ${name} auf ${status} gesetzt`,
    },
    otherChangedPassive: {
        en: (name: string, status: string) => `${name}'s Einladungsstatus wurde auf ${status} gesetzt`,
    },
    participantAdded: {
        en: (actor: string, participant: string) => `${actor} hat ${participant} der Buchung hinzugefügt`,
    },
    participantRemoved: {
        en: (actor: string, name: string) => `${actor} hat ${name} aus einer Buchung entfernt`,
    },
    participantRequestTypeChanged: {
        en: (actor: string, inviteOnly: boolean) => `${actor} hat Mitspielanfragen ${inviteOnly ? "verboten" : "erlaubt"}`,
    },
    participationRequested: {
        en: (actor: string, accepted: boolean) => `${actor} hat eine Mitspielanfrage gestellt${accepted ? ", die automatisch angenommen wurde" : ""}`,
    },
    participationRequestAnswered: {
        en: (actor: string, name: string, accepted: boolean) => `${actor} hat ${name}'s Mitspielanfrage ${accepted ? "angenommen" : "abgelehnt"}`,
    },
    participationRequestCancelled: {
        en: (name: string) => `${name} hat seine Mitspielanfrage zurück gezogen`,
    },
    startTime: {
        en: "Start Time",
        de: "Startzeit",
    },
    type: {
        en: "Type",
        de: "Art",
    },
};

export default localize(i18n);
